import { render, staticRenderFns } from "./CustomerWeeklyReports.vue?vue&type=template&id=b329f242&scoped=true"
import script from "./CustomerWeeklyReports.vue?vue&type=script&lang=ts"
export * from "./CustomerWeeklyReports.vue?vue&type=script&lang=ts"
import style0 from "./CustomerWeeklyReports.vue?vue&type=style&index=0&id=b329f242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b329f242",
  null
  
)

export default component.exports